import { createContext, useState } from "react";
import { getEnvironment, loadAssetsCdnUrl, loadEnvUrl } from "utils/env";
import { getStore, loadBrandParam } from "utils/common";
import appConfig from "./config.json";
import useProfile from "hooks/useProfile";
import { getDefaultLocale, loadLocaleParam, getGDPRLocale } from "utils/locale";

const {
	brands,
	cdn,
	defaultBaseApiUrl,
	content,
	profile,
	email,
	routes,
	searchService,
	searchHistory,
	cache,
	mobileMediaQuery,
	externalScripts,
	focusableElements,
	environments,
	analytics,
	themePath,
	navigation,
	userTypesSearchResultsOpeningInNewTab,
	pathsToHideUserName,
} = appConfig;

export const Context = createContext();
const env = getEnvironment();
const brand = loadBrandParam();
const defaultLocale = getDefaultLocale(brand);
const currentLocale = loadLocaleParam();
const envConfig = environments[env];

const loadAnalyticsConfig = (config) => {
	return {
		baseSiteSection: config?.brands?.[brand]?.analytics?.baseSiteSection || analytics.baseSiteSection,
		site: analytics.site[brand],
		reportSuiteId: config?.brands?.[brand]?.analytics?.reportSuiteId || config.analytics?.reportSuiteId,
	};
};
const getBasePath = () => {
	if (
		brands?.[brand]?.shouldLocalizeUrls === false ||
		getGDPRLocale(brand) ||
		currentLocale === defaultLocale
	) {
		return "";
	}

	return `/${
		brands?.[brand]?.allowedLocales?.[currentLocale] || currentLocale
	}`;
};

const ContextProvider = (props) => {
	const [config] = useState({
		brands,
		brand,
		cdn,
		defaultLocale,
		currentLocale,
		basePath: getBasePath(),
		content,
		profile,
		email,
		routes,
		searchService,
		searchHistory,
		themePath,
		cache,
		pathsToHideUserName,
		mobileMediaQuery,
		externalScripts,
		focusableElements,
		helpAssetsUrl: loadAssetsCdnUrl(
			`${cdn?.baseUrl}${cdn?.helpAssetsPath}`,
			env,
			true
		),
		cdnAssetsUrl: loadAssetsCdnUrl(`${cdn?.baseUrl}${cdn?.cdnAssetsPath}`, env),
		defaultBaseApiUrl: loadEnvUrl(
			brands[brand]?.apiUrl || defaultBaseApiUrl,
			env,
			{ useLt01ApiPrefix: brands[brand]?.useLt01ApiPrefix }
		),
		navigationBaseApiUrl: loadEnvUrl(
			brands[brand]?.navigation?.apiUrl || navigation.apiUrl,
			env,
			{ useLt01ApiPrefix: brands[brand]?.useLt01ApiPrefix }
		),
		store: getStore(),
		userTypesSearchResultsOpeningInNewTab,
		...brands[brand],
		...envConfig?.brands?.[brand],
	});
	const profileData = useProfile(config);
	const analyticsConfig = loadAnalyticsConfig(config);
	const [modal, setModal] = useState(null);
	const [group, setGroup] = useState("help");
	const [interstitials, setInterstitials] = useState({});

	return (
		<Context.Provider
			value={{
				config,
				profileData,
				analyticsConfig,
				modal,
				setModal,
				group,
				setGroup,
				interstitials,
				setInterstitials,
			}}
		>
			{props.children}
		</Context.Provider>
	);
};

export default ContextProvider;
